import React, { useState } from 'react';

// Components
import WpListSelect from '../WpListSelect';
// import WpAvatar from '../../avatar/WpAvatar';

const simpleOptions = ['one', 'two', 'three', 'four', 'twenty-one', 'twenty-two', 'forty', 'ninty-nine'];
const users = [
  {
    id: 103154,
    email: 'josh@9.org',
    fullName: 'joshs 9',
    firstName: 'joshs',
    lastName: '9',
    avatar: {
      color: '#F5C20D',
      initials: 'J9',
      profilePictureUrl: null,
      label: 'joshs 9',
    },
    confirmationSentAt: '2020-11-04T12:36:28.919-08:00',
    confirmedAt: '2020-11-04T12:36:52.137-08:00',
    zoomData: {},
    pulseMood: 'MEH_ROLLING_EYES',
    displayName: 'joshs 9',
    personId: 956624,
    personIdentifier: 'josh@9.org',
    label: 'joshs 9',
    value: 'joshs 9',
    hasSlackNotifications: null,
    role: 'manager',
    organizationRole: 'admin',
    tooltip: 'joshs',
  },
  {
    id: 103155,
    email: 'billy@9.org',
    fullName: 'Billy S',
    firstName: 'Billy',
    lastName: 'S',
    avatar: {
      color: '#D41C8A',
      initials: 'BS',
      profilePictureUrl: null,
      label: 'Billy S',
      tooltip: 'Billy',
    },
    confirmationSentAt: '2020-11-04T12:37:38.580-08:00',
    confirmedAt: '2020-11-04T12:38:10.634-08:00',
    zoomData: {},
    pulseMood: null,
    displayName: 'Billy S',
    personId: 956625,
    personIdentifier: 'billy@9.org',
    label: 'Billy S',
    value: 'Billy S',
    hasSlackNotifications: null,
    role: 'full_member',
    organizationRole: 'admin',
    tooltip: 'Billy',
  },
  {
    avatar: { color: '#5C6ECB', initials: 'DM', profilePictureUrl: null, label: 'dj matthew' },
    confirmationSentAt: '2020-11-04T12:50:30.110-08:00',
    confirmedAt: '2020-11-04T12:51:04.663-08:00',
    displayName: 'dj m',
    email: 'dj@9.org',
    firstName: 'dj',
    fullName: 'dj matthew',
    hasSlackNotifications: null,
    id: 103156,
    label: 'dj matthew',
    value: 'dj matthew',
    lastName: 'matthew',
    organizationRole: 'admin',
    personId: 956626,
    personIdentifier: 'dj@9.org',
    pulseMood: null,
    role: 'full_member',
    type: 'user',
    zoomData: {},
    tooltip: 'matthew',
  },
  {
    avatar: { color: '#D41C8A', initials: 'JJ', profilePictureUrl: null, label: 'Joel Johnson' },
    confirmationSentAt: '2020-11-09T10:50:15.181-08:00',
    confirmedAt: '2020-12-07T09:10:14.547-08:00',
    displayName: 'Joel J',
    email: 'joel@9.org',
    firstName: 'Joel',
    fullName: 'Joel Johnson',
    hasSlackNotifications: null,
    id: 103157,
    label: 'Joel Johnson',
    value: 'Joel Johnson',
    lastName: 'Johnson',
    organizationRole: 'regular_user',
    personId: 956627,
    personIdentifier: 'joel@9.org',
    pulseMood: null,
    role: 'full_member',
    type: 'user',
    zoomData: {},
    tooltip: 'Joel',
  },
  {
    avatar: { color: '#B7D210', initials: 'VH', profilePictureUrl: null, label: 'Victor Hugo' },
    confirmationSentAt: '2020-11-18T17:04:45.494-08:00',
    confirmedAt: '2020-12-02T20:43:37.833-08:00',
    displayName: 'Victor H',
    email: 'victor@9.org',
    firstName: 'Victor',
    fullName: 'Victor Hugo',
    hasSlackNotifications: null,
    id: 103165,
    label: 'Victor Hugo',
    value: 'Victor Hugo',
    lastName: 'Hugo',
    organizationRole: 'regular_user',
    personId: 956635,
    personIdentifier: 'victor@9.org',
    pulseMood: null,
    role: 'full_member',
    type: 'user',
    zoomData: {},
    disabled: true,
    tooltip: 'victor',
  },
];

const ListDocs = () => {
  const WpListSelectExample = () => {
    const [selected, setSelected] = useState([]);
    const handleChange = selected => {
      console.log('selected list items: ', selected);
      setSelected(selected);
    };
    return (
      <>
        <h5 className="mb-3">Simple String options</h5>
        <WpListSelect
          id="demo-1"
          selectedOptions={selected}
          options={simpleOptions}
          direction="column"
          onChange={handleChange}
        />
      </>
    );
  };

  const CustomerOptionInner = () => {
    const [selected, setSelected] = useState([]);
    const handleChange = selected => {
      console.log('selected list items: ', selected);
      setSelected(selected);
    };

    const customOption = ({ option }) => {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* <WpAvatar avatar={option.avatar} size="sm" /> */}
          <span style={{ marginLeft: '8px' }}>{option.email}</span>
        </div>
      );
    };

    return (
      <>
        <h5 className="mt-5 mb-3">Custom Option Inner</h5>
        <WpListSelect
          id="demo-2"
          options={users}
          selectedOptions={selected}
          direction="column"
          onChange={handleChange}
          components={{
            optionInner: customOption,
          }}
        />
      </>
    );
  };

  const Three = () => {
    const [selected, setSelected] = useState([]);

    const handleChange = selected => {
      console.log('selected list items: ', selected);
      setSelected(selected);
    };

    return (
      <>
        <h5 className="mt-5 mb-3">Demo</h5>
        <WpListSelect
          id="demo-2"
          options={['A manager', 'An Individual Contributor']}
          selectedOptions={selected}
          onChange={handleChange}
          direction="horizontal"
          iconNotSelected="circle"
          iconSelected="check"
          max={1}
          disableOnMax={false}
        />
      </>
    );
  };

  const CustomIconObject = () => {
    const [selected, setSelected] = useState([]);

    const handleChange = selected => {
      console.log('selected list items: ', selected);
      setSelected(selected);
    };

    return (
      <>
        <h5 className="mt-5 mb-3">Custom Icon Object</h5>
        <WpListSelect
          id="demo-2"
          options={['A manager', 'An Individual Contributor']}
          selectedOptions={selected}
          onChange={handleChange}
          direction="horizontal"
          iconNotSelected={{ name: 'circle', prefix: 'fal' }}
          iconSelected={{ name: 'check-circle', prefix: 'fas' }}
          max={1}
          disableOnMax={false}
        />
      </>
    );
  };

  return (
    <>
      <WpListSelectExample />
      <CustomerOptionInner />
      <Three />
      <CustomIconObject />
    </>
  );
};

export default ListDocs;
